import React, { ReactElement } from 'react';
import { NavLink } from 'react-router-dom';
import { ListItem, ListItemButton, ListItemIcon, ListItemText } from '@mui/material';
import { SideNavigationItemProps } from './types';

const SideNavigationItem = React.forwardRef<HTMLLIElement, SideNavigationItemProps>(
	({ itemTitle, icon, path, onClick, openInNewTab = false, ...props }, ref): ReactElement => {
		const listItemButtonProps = path
			? { component: NavLink, to: path, target: openInNewTab ? '_blank' : undefined }
			: { onClick };

		return (
			<ListItem disablePadding {...props} ref={ref}>
				<ListItemButton
					color="primary.main"
					{...listItemButtonProps}
					sx={{ cursor: path || onClick ? 'pointer' : 'default' }}
				>
					<ListItemIcon>{icon}</ListItemIcon>
					<ListItemText
						primary={itemTitle}
						primaryTypographyProps={{
							style: { textOverflow: 'ellipsis', overflow: 'hidden' },
						}}
					/>
				</ListItemButton>
			</ListItem>
		);
	}
);

export default SideNavigationItem;
